/* eslint-disable */
import React, { useState, useEffect } from 'react';
import { useSelector } from 'react-redux';
import { Skeleton, Box } from '@mui/material';
import { NavHashLink } from 'react-router-hash-link';
import PARSE, { domToReact } from 'html-react-parser';
import Api from './Api';
import Background from './assets/cek.png';
import Background2 from './assets/cek2.png';
import G1 from './assets/g1.png';
import G2 from './assets/g2.png';
import G3 from './assets/g3.png';
import G4 from './assets/g4.png';

function SSoft_About_Us() {
  const [sectionItems, setSectionItems] = useState([]);
  const activeLang = useSelector((state) => state.content.activeLanguage);
  const path = window.location.pathname;

  const DummyIcon = [G1, G2, G3, G4]

  useEffect(() => {
    const fetchData = async () => {
      const api = new Api();
      const sectionResponse = await api.getSectionDetail({ language: activeLang });
      const sectionData = sectionResponse;

      setSectionItems(sectionData.data.results[0]);
    };

    fetchData();
  }, [activeLang]);

  let titles;
  let articles;
  const images = [];
  let statIcons;
  const articlesStats = [];
  if (sectionItems) {
    const secWidgets = sectionItems.widgets;

    secWidgets?.forEach((data, id) => {
      const secWidgetContents = data.widget_contents;

      switch (id) {
        case 0:
          images.push(...secWidgetContents);
          break;
        case 1:
          titles = data?.widget_contents[0]?.article_language;
          break;
        case 2:
          statIcons = secWidgetContents;
          break;
        case 3:
          secWidgetContents.forEach((data) => {
            articlesStats.push(data.article_language);
          });
          break;
        case 4:
          articles = secWidgetContents;
          break;
        default:
          break;
      }
    });
  }

  const options = {
    replace: ({ attribs, children }) => {
      if (!attribs) {
        return;
      }

      if (children[0]?.type === 'text') {
        return (
          <h2 className="text-[#E12726] flex-nowrap text-[16px] hd2xl:text-[20px]" style={{ fontWeight: '600', lineHeight: '130%' }}>
            {domToReact(children, options)}
          </h2>
        );
      }
    },
  };

  return (
    <div id={`${sectionItems?.slug_name}`} className="w-full h-full relative">
      <div
        className={`absolute right-0 top-0 h-full w-[120px] s:w-[250px] mdl:w-[327px]`}
        style={{
          backgroundImage: `linear-gradient(to right, rgba(255, 255, 255, 1), rgba(255, 255, 255, 0)), url(${Background2})`,
          backgroundSize: 'cover',
          backgroundPosition: 'right top',
          backgroundRepeat: 'repeat',
          zIndex: '-10',
        }}
        aria-label={images[1]?.description}
      ></div>
      <div className="section-container h-full py-[120px] fhd:py-[150px] hd:px-[120px]">
        <div className="max-w-[922px] fhd:max-w-[1300px] sm:min-h-[616px] space-y-20">
          <div className="section-heading w-full space-y-[45px]">
            <h1 className="w-full sm:w-[585px] fhd:w-[566px] fhd:text-[30px]">{titles && titles.title}</h1>
            {titles && typeof titles.content === 'string' && titles.content !== '' && (
              <p className="prose max-w-none prose-p:text-[16px] prose-p:fhd:text-[20px]">{PARSE(titles.content)}</p>
            )}
          </div>
          <div className="w-full flex flex-col sm:flex-row justify-between gap-y-[30px] gap-x-[20px] lg:gap-x-[30px]">
            {sectionItems.length !== 0 && articles ? (
              articlesStats.map((article, id) => {
                return (
                  <div key={article.id} className="w-full sm:w-[380px] h-full px-0 lg:px-[30px] py-[30px] lg:py-[45px] bg-[#FAF8F5] space-y-[5px]">
                    <div className="w-full flex justify-center">
                      <img className="w-[65px] h-[65px] hd2xl:w-[70px] hd2xl:h-[70px]" src={statIcons[id]?.file_medium} alt={statIcons[id]?.description} />
                    </div>
                    <div className="flex flex-col align-middle items-center gap-y-2.5">
                      <h1 className="text-[45px] sm:text-[35px] md:text-[64px] hd2xl:text-[68px] text-[#E12726] font-bold leading-[120%]">{article.title}</h1>
                      {PARSE(article.content, options)}
                    </div>
                  </div>
                );
              })
            ) : (
              <Box className="w-full h-[300px]" />
            )}
          </div>
          <div className="w-full grid grid-cols-1 sm:grid-cols-2 gap-x-10 md:gap-x-20 fhd:gap-x-24 gap-y-10 sm:gap-y-7 hdxl:gap-y-12">
            {articles &&
              articles.map((article, index) => {
                const icon = article.assets[0]?.file_small;
                const iconDesc = article.assets[0]?.description;
                const { article_language } = article;

                return (
                  <div key={article.id} className={`w-full ${article_language?.summary === '' ? 'min-h-[217px]' : 'justify-between'} flex flex-col space-y-[20px]`}>
                    <div className="max-h-[82px]">
                      <img className="scale-50 origin-top-left" src={icon} alt={iconDesc} />
                    </div>
                    <div className="h-fit space-y-2">
                      <h2 className="data-heading fhd:text-[26px] mb-[5px]">{article_language?.title}</h2>
                      <p className="prose prose-p:fhd:text-[20px] prose-p:font-inter">{PARSE(article_language?.content)}</p>
                    </div>
                    {article_language?.summary && (
                      <NavHashLink className="flex gap-x-2.5 text-cuzTurquoise w-fit" smooth to={article_language?.path || '/'}>
                        <img className="w-[24px] h-[24px]" src={images && images[0]?.file_medium} alt={images[0]?.description} />
                        <p className="fhd:text-[20px]">{article_language.summary}</p>
                      </NavHashLink>
                    )}
                  </div>
                );
              })}
          </div>
        </div>
      </div>
    </div>
  );
}

export default SSoft_About_Us;
